export default __webpack_public_path__ + "static/media/rating.a1f8bff6.svg";